import { QUIZ_MILESTONES } from '../constants';
import { getActiveStepKeys } from '../steps';

export const resolveQuizProgress = flags => {
  const active = new Set(getActiveStepKeys(flags));
  const steps = QUIZ_MILESTONES.filter(step => active.has(step));

  return {
    totalSteps: steps.length,
    getStepNumber: step => {
      const index = steps.indexOf(step);
      return index === -1 ? null : index + 1;
    },
  };
};

export const resolveQuizProgressStep = (flags, step) => {
  const { totalSteps, getStepNumber } = resolveQuizProgress(flags);

  return {
    totalSteps,
    stepNumber: getStepNumber(step),
  };
};
